<div class="simple-page-container service-page">

  <div class="container">

<!--    <div class="page-heading">-->
<!--      <h1 class="page-title">{{'MENU.MENU_3' | translate}}</h1>-->
<!--      <hr class="divider">-->

<!--    </div>-->


    <div class="service-list-container">

      <div class="row">

        <div class="col-12 col-md-6" *ngFor="let item of [0,1]; let i = index">
          <mat-card>
            <mat-card-header>
              <mat-card-title>{{'SERVICES.ITEM_' + i + '.TITLE' | translate}}</mat-card-title>
            </mat-card-header>
            <div class="service-item-image" [ngStyle]="getBackgroundImageStyle(i)"></div>
            <mat-card-content>
              <p>
                {{'SERVICES.ITEM_' + i + '.DESCRIPTION' | translate}}
              </p>
            </mat-card-content>
          </mat-card>

        </div>


      </div>


    </div>


  </div>
</div>
